// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","topHeader":"Header_topHeader__1cLaj","logo":"Header_logo__3T0lc","link":"Header_link__1uLZ-","brand":"Header_brand__1Eas8"};